import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-127">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-128">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-129">🤝 CENTRALPACK™</h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-130">
          El sistema N°1 para aprender Lenguaje de Señas Argentina de manera
          progresiva, práctica y adaptada a la vida real en Argentina.
          <br data-id="element-131" />
          <strong className="text-slate-300 mt-2 block" data-id="element-132">
            Porque comunicarse con una persona sorda no debería ser imposible
            para nadie.
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-133">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-white transition-colors" data-id="element-134">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-135">·</span>
          <span className="hover:text-white transition-colors" data-id="element-136">
            📱 @centralpack.ar
          </span>
          <span className="hidden sm:inline" data-id="element-137">·</span>
          <span className="hover:text-white transition-colors" data-id="element-138">
            🌐 www.centralpack.shop
          </span>
        </div>

        <div className="text-xs text-slate-600 border-t border-slate-800 pt-8" data-id="element-139">
          <p className="mb-2" data-id="element-140">
            © CentralPack™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="italic" data-id="element-141">
            🤟 "La próxima vez que estés frente a una persona sorda, vas a poder
            comunicarte."
          </p>
        </div>
      </div>
    </footer>;
}